import { createFileRoute } from "@tanstack/react-router";
import { CartPage } from "../components/shop/cart-page.tsx";

export const Route = createFileRoute("/butik/varukorg")({ component: CartPage });
